import { render } from "./Agree.vue?vue&type=template&id=0c42989a&scoped=true"
import script from "./Agree.vue?vue&type=script&lang=js"
export * from "./Agree.vue?vue&type=script&lang=js"

import "./Agree.vue?vue&type=style&index=0&id=0c42989a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c42989a"]])

export default __exports__